import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function BookingCancelled() {
  return (
    <div className="min-h-[60vh] container-x section-y flex items-center bg-ink" data-testid="booking-cancelled-page">
      <div className="max-w-xl mx-auto card-brutal text-center w-full">
        <XCircle size={36} className="mx-auto text-rose" />
        <p className="mt-5 font-display text-3xl uppercase text-white">Payment cancelled</p>
        <p className="mt-3 text-white/75">
          No worries — your booking was not saved and no payment was taken.
          Try again whenever you're ready.
        </p>
        <Link to="/workshops" className="mt-6 btn-accent inline-flex">Back to workshops</Link>
      </div>
    </div>
  );
}
